import type { TaskMergeOptions } from "./options/TaskMergeOptions"
import type { TaskPlotOptions } from "./options/TaskPlotOptions"
import type { TaskRasterizeOptions } from "./options/TaskRasterizeOptions"
import type { TaskSplitOptions } from "./options/TaskSplitOptions"
import type { TaskZipOptions } from "./options/TaskZipOptions"

export type TaskOptions =
  | TaskMergeOptions
  | TaskPlotOptions
  | TaskRasterizeOptions
  | TaskSplitOptions
  | TaskZipOptions
